import Icon from '../components/Icon.vue'

Icon.register({"cut":{"width":448,"height":512,"paths":[{"d":"M444.5 422.4C449.2 427.1 449.2 434.7 444.5 439.4 411.7 472.2 358.5 472.2 325.7 439.4L210.2 323.9 185.3 348.7C189.6 359.7 192 371.6 192 384 192 437 149 480 96 480S0 437 0 384 43 288 96 288C100.5 288 105 288.3 109.4 288.9L142.3 256 109.4 223.1C105 223.7 100.5 224 96 224 43 224 0 181 0 128S43 32 96 32 192 75 192 128C192 140.4 189.6 152.3 185.3 163.3L210.2 188.1 325.7 72.6C358.5 39.8 411.7 39.8 444.5 72.6 449.2 77.3 449.2 84.9 444.5 89.6L278.1 256 444.5 422.4zM96 96C78.4 96 64 110.4 64 128S78.4 160 96 160 128 145.6 128 128 113.6 96 96 96M96 352C78.4 352 64 366.4 64 384S78.4 416 96 416 128 401.6 128 384 113.6 352 96 352M208 244C201.4 244 196 249.4 196 256S201.4 268 208 268 220 262.6 220 256 214.6 244 208 244z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cut.js
// module id = WB1I
// module chunks = 0